import angular from 'angular';

export function InsightReportMarketAnalysisCurrencyFormatter(FormatterService, CURRENCY_CODES) {
    const getFormattedSalary = ({ minValue, maxValue } = {}) => {
        const currencyFormatter = FormatterService.getCurrencyFormatter(CURRENCY_CODES.USD);

        if (!minValue && !maxValue) {
            return '';
        }

        if (minValue && !maxValue) {
            return `${currencyFormatter.format(minValue)}K`;
        }

        if (!minValue && maxValue) {
            return `${currencyFormatter.format(maxValue)}K`;
        }

        if (minValue && maxValue) {
            const formattedMinValue = currencyFormatter.format(minValue);
            const formattedMaxValue = currencyFormatter.format(maxValue);

            return `${formattedMinValue}K - ${formattedMaxValue}K`;
        }
    };

    return {
        getFormattedSalary,
    };
}

export const formatSalary = InsightReportMarketAnalysisCurrencyFormatter =>
    salaryValue => InsightReportMarketAnalysisCurrencyFormatter.getFormattedSalary(salaryValue);

angular.module('TALENYA-FE').factory('InsightReportMarketAnalysisCurrencyFormatter', InsightReportMarketAnalysisCurrencyFormatter);

angular.module('TALENYA-FE').filter('formatSalary', formatSalary);
